/**
 * @author - steves165
 */

(function() {
    'use strict';

    function sanitizeHtml(html) {
        var cleaned = '';
        if (!/script/.test(html) || !/<style/.test(html)) {
            cleaned = html;
        } else {
            cleaned = html.replace(/<script>[\s\S]*?<\/script>/, '').replace(/<style>[\s\S]*?<\/style>/, '');
        }

        return cleaned;
    }

    /*global angular*/
    angular.module('vhols')
		/**
		 * Filter for trusting html. (Andy says use more filters)
		 */
        .filter('to_trusted', ['$sce', function($sce){
            return function(text) {
                var cleaned = sanitizeHtml(text);
                return $sce.trustAsHtml(cleaned);
            };
        }])

        .filter('spacer', [function () {
            return function (text) {
                return text.replace("_", " ");
            };
        }])

        .filter('slice', [function() {
            return function(arr, start, end) {
                return (arr || []).slice(start, end);
            };
        }])
	
		.filter('unsnake', [function() {
			return function(text) {
				return vhols.unsnakecase(text).replace('holidays', '');
			};
		}])

        .filter('unholidays', [function() {
            return function(link) {
                return link.replace(/-holidays/g, '') + '-holidays';
            };
        }]);
})();